// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2yyVp","select":"Header_select__31_7r","clinic":"Header_clinic__2f37m"};